import { useState } from 'react';

export default function TextAreaTail({ label, description, setSomething, value, characterGoal, placeholder }) {
  const [isLoading, setIsLoading] = useState(false);

  const characterCount = value.length;
  const progressValue = (characterCount / characterGoal) * 100;

  let progressColor;
  if (progressValue < 25) {
    progressColor = 'progress-error';
  } else if (progressValue < 70) {
    progressColor = 'progress-warning';
  } else if (progressValue < 100) {
    progressColor = 'progress-secondary';
  } else {
    progressColor = 'progress-success';
  }

  return (
    <div className="flex text-left space-x-4">
      <div className="min-w-0 flex-1 w-full">
        <label htmlFor="comment" className="font-medium">
          {label}
        </label>
        <div className="mb-3">
          <p className="text-sm text-gray-500 text-left">{description}</p>
        </div>
        {characterGoal && characterCount > 0 && (
          <div className=''>
            <progress className={`progress ${progressColor} w-56`} value={characterCount} max={characterGoal}></progress>
          </div>
        )}
        <div className="overflow-hidden rounded-lg shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 flex-grow">
          <textarea
            rows={1}
            name="comment"
            id="comment"
            className="block w-full resize-none border-0 bg-transparent text-md text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-0 sm:leading-6 h-full sm:py-3 py-0"
            value={value}
            placeholder={placeholder}
            onChange={(event) => setSomething(event.target.value)}
          />
        </div>
      </div>
    </div>
  );
}
